export const process3LevelBucketsData = (buckets: any[]): Record<string, any> => {
  const dataMap: Record<string, any> = {};

  buckets.forEach((level1Bucket) => {
    const workspace = level1Bucket.key;
    dataMap[workspace] = {};

    level1Bucket.aggregation?.buckets?.forEach((level2Bucket) => {
      const platform = level2Bucket.key;
      dataMap[workspace][platform] = {};

      level2Bucket.aggregation?.buckets?.forEach((level3Bucket) => {
        const type = level3Bucket.key;

        level3Bucket.aggregation?.buckets?.forEach((finalBucket) => {
          const date = finalBucket.key_as_string ?? '';
          const value = finalBucket.value?.value ?? 0;

          if (!dataMap[workspace][platform][type]) {
            dataMap[workspace][platform][type] = {};
          }

          dataMap[workspace][platform][type][date + '_users'] = value;
          dataMap[workspace][platform][type][date + '_candidates'] = finalBucket?.doc_count ?? 0;
        });
      });
    });
  });

  return dataMap;
};

export const collectUniqueDatesFrom3Levels = (buckets: any[]): Set<string> => {
  const datesSet = new Set<string>();

  buckets.forEach((level1Bucket) => {
    level1Bucket.aggregation?.buckets?.forEach((level2Bucket) => {
      level2Bucket.aggregation?.buckets?.forEach((level3Bucket) => {
        level3Bucket.aggregation?.buckets?.forEach((finalBucket) => {
          if (finalBucket.key_as_string) {
            datesSet.add(finalBucket.key_as_string);
          }
        });
      });
    });
  });

  return datesSet;
};

export const collectUniqueDatesFrom1Level = (buckets: any[]): string[] => {
  const datesSet = new Set<string>();

  buckets.forEach((item) => {
    item.aggregation?.buckets?.forEach((bucket) => {
      if (bucket.key_as_string) {
        datesSet.add(bucket.key_as_string);
      }
    });
  });
  return Array.from(datesSet).sort((a, b) => b.localeCompare(a));
};

export const collectUniqueDatesFrom2Levels = (buckets: any[]): string[] => {
  const datesSet = new Set<string>();

  buckets.forEach((item) => {
    item.aggregation?.buckets?.forEach((bucket1) => {
      bucket1.aggregation?.buckets?.forEach((bucket2) => {
        if (bucket2.key_as_string) {
          datesSet.add(bucket2.key_as_string);
        }
      });
    });
  });
  return Array.from(datesSet).sort((a, b) => b.localeCompare(a));
};
